<template>
    <div class="">
        <van-form @submit="login">
            <van-field
                    v-model="phone"
                    type="tel"
                    name="手机号"
                    label="手机号"
                    placeholder="请输入手机号"
            ></van-field>
            <van-field
                    v-model="pwd"
                    type="password"
                    name="密码"
                    label="密码"
                    placeholder="请输入密码"
            ></van-field>
            <div style="margin: 32px 16px;">
                <div style="margin-bottom:15px;color: #ee0a24;text-align: center">
                    <div>如果已使用微信公众号授权登录，请使用绑定的手机号登录</div>
                </div>
                <van-button  block type="info" native-type="submit">登   录</van-button>
                <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
                    <div class="register-btn weball-font-14" @click="go_findpwd">找回密码</div>
                    <div class="register-btn weball-font-14" @click="go_register">新用户注册</div>
                </div>
            </div>
        </van-form>
    </div>
</template>
<script>
    export default {
        name: 'phonelogin',
        data() {
            return {
                phone: '',
                pwd: '',
            }
        },
        created: function () {

        },
        methods: {
            login: function () {
                if(!this.weutil.isPoneAvailable(this.phone)){this.$toast('手机号不正确！');return;}
                if(this.pwd===''){this.$toast('请输入密码！');return;}
                let that = this;
                this.weapi.request({
                    url: 'login',
                    method: 'post',
                    params: {'phone':this.phone, 'pwd':this.pwd},
                }).then(res => {
                    if (res.data.code === '200') {
                        that.westore.commit('setToken', res.data.data.access_token)
                        that.eventbus.$emit(this.weconfig.event.loginChanged, true);
                        window.history.back();
                    }
                    else {
                        that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            go_findpwd:function(){
                this.$router.push({ name: this.werouter.resetpwd.name})
            },
            go_register:function () {
                this.$router.push({ name: this.werouter.register.name})
                // window.location.href = this.weconfig.baseUrl + "/register";
            }
        }
    }
</script>

<style>
    .content-wrap{
        margin-top:10%;
    }
    .register-btn{
        margin:30px 10px;
        color: #999;
        /*text-align: right;*/
    }
</style>
